import { IMPERSONATION_COOKIE, IMPERSONATION_TOKEN_PREFIX } from '~/lib/impersonation'

/**
 * #743 — client-side counterpart of the server's `resolveApiAccessToken`.
 *
 * While an admin impersonates, the `wmi_` bearer lives in a same-site cookie
 * (deliberately NOT HttpOnly — this helper is why). Server components already
 * substitute it; client pages that build their own Authorization header from
 * `supabase.auth.getSession()` were still sending the ADMIN's JWT, so every
 * member surface (/me, /settings, /billing, /support) showed the admin's own
 * data instead of the target's.
 *
 * Wrap the supabase access token at the header boundary:
 *   Authorization: `Bearer ${withImpersonation(session.access_token)}`
 *
 * Ends cleanly: exiting impersonation clears the cookie, so the same call
 * transparently reverts to the admin's own token.
 */
export function withImpersonation(token: string): string {
  if (typeof document !== 'undefined') {
    const match = document.cookie
      .split(';')
      .map((p) => p.trim())
      .find((p) => p.startsWith(`${IMPERSONATION_COOKIE}=`))
    if (match) {
      const value = decodeURIComponent(match.slice(IMPERSONATION_COOKIE.length + 1))
      if (value.startsWith(IMPERSONATION_TOKEN_PREFIX)) return value
    }
  }
  return token
}
